// extracted by mini-css-extract-plugin
module.exports = {"header":"_830e6ac","dark":"_94a8f9e"};